import { getFrontendConfig } from '../../config/frontendConfig';

declare var window: any;

var UrlUtilities = {
    getApiUrl: function () {
        return getFrontendConfig().urls.apiBaseUrl;
    },

    getImageBaseUrl: function () {
        return "";
    },

    getBaseUrl: function () {
        return window.BASE_URL;
    },

    getApplicationUrl: function() {
        return window.APP_URL;
    },

    getBaseApplicationUrl: function () {
        return "";
    },

    getOtherApplicationUrl: function (appName: string) {
        return window.BASE_URL + "/" + appName;
    }
}

export default UrlUtilities;
